import {
    DELETE_PRODUCT_FAILED , DELETE_PRODUCT_SUCCESS , DELETE_PRODUCT_LOADING
    } from "../types";
    
    const initialState = {
      loading: false,
      error: null,
      status: null,
      message:null ,
    };
    
    export const DeleteProductReducer = (
      state = initialState,
      action: { type: any; loading:boolean , payload: any, error: any, status: string , message : string  }
    ) => {
      switch (action.type) {
        case DELETE_PRODUCT_LOADING:
          return {
            ...state,
            loading: action.loading,
          };
        case DELETE_PRODUCT_SUCCESS:
         //
          return {
            ...state,
            loading: false,
            status: action.payload,
            message:action.payload ,
            error: null,
          };
        case DELETE_PRODUCT_FAILED:
          return {
            ...state,
            loading: false,
            status: null,
            message:null , 
            error: action.error,
          };
          
        default:
          return state;
      }
    };
    